import { IImageDrawableObject, instanceOfIImageDrawableObject } from "./IImageDrawableObject";
import { ElementTypes } from "./ElementTypes";

export interface IClaioMediaDrawableObject extends IImageDrawableObject {
  // TODO: 独自要素の実装.(E大ではClaioメディアを設定する事はないので優先度低.)
}

export function instanceOfIClaioMediaDrawableObject<T extends IClaioMediaDrawableObject>(instance: any, type: ElementTypes): instance is IClaioMediaDrawableObject {
  return instance
      && instanceOfIImageDrawableObject<T>(instance, type);
}
